module.exports = __webpack_public_path__ + "static/media/fieldplusplus.2b58d9a8.png";